import { useAtomValue, useSetAtom } from "jotai";
import { useCallback, useEffect } from "react";
import { useHistory, useLocation } from "react-router";
import ChatModalAtom from "utilities/atoms/chat-modal-atom";
import { RouteUtils } from "utilities/route-utils";

export const CASI_QUERY_PARAM_NAME = "casi";

export const useChatModalState = () => {
    const modalOptions = useAtomValue(ChatModalAtom);

    return modalOptions;
};

export const useChatModalActions = () => {
    const setOptions = useSetAtom(ChatModalAtom);
    const { search, pathname } = useLocation();
    const { replace } = useHistory();

    const openChatModal = useCallback(() => {
        const params = new URLSearchParams(search);
        params.set(CASI_QUERY_PARAM_NAME, "true");
        const paramsAsObj = RouteUtils.queryStringToObject(params.toString());
        replace(RouteUtils.appendQueryParams(pathname, paramsAsObj));
    }, [pathname, replace, search]);

    const closeChatModal = useCallback(() => {
        const params = new URLSearchParams(search);
        params.delete(CASI_QUERY_PARAM_NAME);
        const paramsAsObj = RouteUtils.queryStringToObject(params.toString());
        replace(RouteUtils.appendQueryParams(pathname, paramsAsObj));
    }, [pathname, replace, search]);

    const setStartingPrompt = useCallback(
        (prompt: string | undefined) => {
            setOptions((prev) => ({ ...prev, startingPrompt: prompt }));
        },
        [setOptions]
    );

    return { closeChatModal, openChatModal, setStartingPrompt };
};

export const useChatModal = () => {
    const modalOptions = useChatModalState();
    const modalActions = useChatModalActions();
    return { ...modalOptions, ...modalActions };
};

export const useSyncOpenStateToAtom = () => {
    const { search } = useLocation();
    const setChatModal = useSetAtom(ChatModalAtom);

    useEffect(() => {
        const isOpen = !!RouteUtils.queryStringToObject<{
            [CASI_QUERY_PARAM_NAME]: boolean;
        }>(search)[CASI_QUERY_PARAM_NAME];

        setChatModal((prev) => ({
            ...prev,
            isOpen,
        }));
    }, [search, setChatModal]);
};
